/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import { KTSVG } from '../../../helpers'

type Props = {
  className?: string
  functionSubmit?: any
  selectedMinCount?: string
}

const changeDropDownText = (e: React.MouseEvent<Element, MouseEvent>) => {
  const target = e.target as HTMLInputElement;
  target.parentElement!.parentElement!.parentElement!.children[0].children[0].textContent = target.textContent
}

const DropdownFilterMinCount: FC<Props> = ({ 
  className = '', 
  functionSubmit,
  selectedMinCount = '5',
}) => {
  return (
    <div className= {className}>
      <a href='#' className='btn btn-light btn-active-light-primary btn-sm' data-kt-menu-trigger='click' data-kt-menu-placement='bottom-end'>
        <div style={{ display: 'unset' ,margin:'auto'}}>{LanguageHelp('Topic Occurrence Threshold')}: {selectedMinCount}</div>
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4' data-kt-menu='true'>
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit('3', 'minCount'); changeDropDownText(e); }}>
            {'3'}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit('5', 'minCount'); changeDropDownText(e); }}>
            {'5'}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit('10', 'minCount'); changeDropDownText(e); }}>
            {'10'}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit('20', 'minCount'); changeDropDownText(e); }}>
            {'20'}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit('30', 'minCount'); changeDropDownText(e); }}>
            {'30'}
          </a>
        </div>
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </div>
  )
}

export { DropdownFilterMinCount }
